module.exports = __webpack_public_path__ + "media/bootstrap-icons/puzzle-9eff01c6.svg";